import { AbstractControl, ValidationErrors } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { validateDependentField } from "./validate-dependent-field";

export function validateAddress(control: AbstractControl, field: FormlyFieldConfig): ValidationErrors | null {
  const requiredFields = ['city', 'line1', 'zip'];
  return validateDependentField(control, field, requiredFields, 'addressInvalid');
}
